import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import SplashScreen from "@/components/SplashScreen";

export default function ProtectedRoute({ children }) {
  const { user, isGuest, loading } = useAuth();
  if (loading) return <SplashScreen />;
  if (!user && !isGuest) return <Navigate to="/welcome" replace />;
  return children;
}
